import { EmployeePositionData } from '@pxtra-client-lib-legacy/gen';
import { FC } from 'react';
import { Loading } from '../../../../lib/components';
import { DataGrid } from '../../../../lib/components/compound/dataGrid';
import Util from '../../../../misc/util';
import { EmployeeDataGridElement } from '../shared/dataGridElement';

interface Props {
  data: EmployeePositionData | undefined;
}

export const PositionDataView: FC<Props> = ({ data }) => {
  return data ? (
    <DataGrid>
      <EmployeeDataGridElement data={data} field="position_name" />
      <EmployeeDataGridElement data={data} field="employee_number" />
      <EmployeeDataGridElement data={data} field="location" xs={12} />
      <EmployeeDataGridElement data={data} field="department" />
      <EmployeeDataGridElement data={data} field="cost_center" />
      <EmployeeDataGridElement
        data={data}
        field="entry_date"
        renderValue={(date) => (date ? Util.formatDate(date as string) : '')}
      />
      <EmployeeDataGridElement
        data={data}
        field="exit_date"
        renderValue={(date) => (date ? Util.formatDate(date as string) : '')}
      />
      <EmployeeDataGridElement data={data} field="working_hours_per_week" />
      <EmployeeDataGridElement data={data} field="working_days_per_week" />
      <EmployeeDataGridElement data={data} field="note" xs={12} />
    </DataGrid>
  ) : (
    <Loading />
  );
};
